import { ArticleContent } from 'components/container'
import { Layout } from 'components/layout'
import { GlobalStyleLight } from 'styles/global-light'
import { PageNav } from 'components/page-nav'
import { PageHeader } from 'components/page-header'
import HeaderImg from './assets/komi_illustr_6.webp'
import { useSectionObserver } from 'hooks/use-section-observer'
import { Flower } from './sections/flower'
import { Vocabulary } from './sections/vocabulary'
import { Alphabet } from './sections/alphabet'
import { Mythology } from './sections/mythology'
import { Doll } from './sections/doll'
import { Flag } from './sections/flag'
import { Ornaments } from './sections/ornaments'
import { Intro } from './sections/intro'
import { Theme } from './styled'

export const Komi = () => {
  const { addItem } = useSectionObserver()

  return (
    <Layout invertedHeader>
      <GlobalStyleLight />
      <Theme />
      <PageNav />

      <PageHeader title="Коми" imageRatio="2608 / 1518" imageUrl={HeaderImg} />

      <ArticleContent>
        <Intro />
        <Mythology ref={addItem} />
        <Flower />
        <Flag ref={addItem} />
        <Doll />
        <Alphabet ref={addItem} />
        <Vocabulary ref={addItem} />
        <Ornaments ref={addItem} />
      </ArticleContent>
    </Layout>
  )
}
